import React, { useState } from 'react';

const exampleSystemPrompt =
  'You are a student motivator. Write a script in Hinglish with a motivational tone, focusing on study motivation and hacks. Structure: Problem, Hack, Uplifting Encouragement. Use 2 emojis and a hashtag. End with a challenge to the audience. Keep it under 70 words.';
const exampleUserPrompt =
  'Topic: How to stay motivated in exams Language: Hinglish Tone: motivational Give a motivational study hack and challenge viewers.';
const openAIModels = [
  { label: 'gpt-4o', value: 'gpt-4o' },
  { label: 'gpt-4', value: 'gpt-4' },
  { label: 'gpt-3.5-turbo', value: 'gpt-3.5-turbo' },
  { label: 'gpt-3.5-turbo-16k', value: 'gpt-3.5-turbo-16k' },
];

const googleModels = [
  { label: 'gemini-1.5-pro-latest', value: 'gemini-1.5-pro-latest' },
  { label: 'gemini-1.5-pro-001', value: 'gemini-1.5-pro-001' },
  { label: 'gemini-1.5-pro-002', value: 'gemini-1.5-pro-002' },
  { label: 'gemini-1.5-pro', value: 'gemini-1.5-pro' },
  { label: 'gemini-1.5-flash-latest', value: 'gemini-1.5-flash-latest' },
  { label: 'gemini-1.5-flash-001', value: 'gemini-1.5-flash-001' },
  { label: 'gemini-1.5-flash-001-tuning', value: 'gemini-1.5-flash-001-tuning' },
  { label: 'gemini-1.5-flash', value: 'gemini-1.5-flash' },
  { label: 'gemini-1.5-flash-002', value: 'gemini-1.5-flash-002' },
  { label: 'gemini-1.5-flash-8b', value: 'gemini-1.5-flash-8b' },
  { label: 'gemini-1.5-flash-8b-001', value: 'gemini-1.5-flash-8b-001' },
  { label: 'gemini-1.5-flash-8b-latest', value: 'gemini-1.5-flash-8b-latest' },
  { label: 'gemini-2.0-flash', value: 'gemini-2.0-flash' },
  { label: 'gemini-2.0-flash-001', value: 'gemini-2.0-flash-001' },
  { label: 'gemini-2.0-flash-lite-001', value: 'gemini-2.0-flash-lite-001' },
  { label: 'gemini-2.0-flash-lite', value: 'gemini-2.0-flash-lite' },
  { label: 'gemma-3-1b-it', value: 'gemma-3-1b-it' },
  { label: 'gemma-3-4b-it', value: 'gemma-3-4b-it' },
  { label: 'gemma-3-12b-it', value: 'gemma-3-12b-it' },
  { label: 'gemma-3-27b-it', value: 'gemma-3-27b-it' },
];

const groqModels = [
  { label: 'allam-2-7b', value: 'allam-2-7b' },
  { label: 'compound-beta', value: 'compound-beta' },
  { label: 'compound-beta-mini', value: 'compound-beta-mini' },
  { label: 'deepseek-r1-distill-llama-70b', value: 'deepseek-r1-distill-llama-70b' },
  { label: 'gemma2-9b-it', value: 'gemma2-9b-it' },
  { label: 'llama-3.1-8b-instant', value: 'llama-3.1-8b-instant' },
  { label: 'llama-3.3-70b-versatile', value: 'llama-3.3-70b-versatile' },
  { label: 'llama-guard-3-8b', value: 'llama-guard-3-8b' },
  { label: 'llama3-70b-8192', value: 'llama3-70b-8192' },
  { label: 'llama3-8b-8192', value: 'llama3-8b-8192' },
  { label: 'meta-llama/llama-4-scout-17b-16e-instruct', value: 'meta-llama/llama-4-scout-17b-16e-instruct' },
  { label: 'qwen-qwq-32b', value: 'qwen-qwq-32b' },
];

const EXAMPLES = [
    {
        model: "gpt-4o",
        prompt_number: 1,
        script: "(1) Yaar, woh feeling pata hai na jab exam ka timetable samne ho aur motivation kahi churrr ho jaaye? 🤯\n\n(2) Par suno, plot twist toh yeh hai—hamara dimaag cheat code ban sakta hai! Jaise game mein unlock karte ho waise hi, small breaks aur music playlist se apni energy up karo! 🎧✨\n\n(3) Soch badi rakho, action mazedaar karo—notes ko memes bana do, ya phir kahani ki tarah yaad karo. #StudySmartNotHard\n\nComments mein apne study hacks share karo ya usse tag karo jo hamesha chill rehta hai! 🚀📚",
        system_prompt: "You are a viral content architect for Indian Gen-Z. Write a script in Hinglish with a motivational tone. Structure: 1. Relatable Hook, 2. Unexpected Twist, 3. Actionable Takeaway. Use trending slang, punchy lines, and at least one emoji and hashtag. End with a call for comments or shares. Keep it under 90 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it viral and interactive."
    },
    {
        model: "gpt-4o",
        prompt_number: 2,
        script: "**Dramatic Hook:**\n\n(*Background music builds, leading to a crescendo as hero Vir stares at his books, feeling dejected.*)\n\n**Vir:** \"Baba kehte the, sapne wahi dekh, jise tu haqiqat bana sake.\" 😢\n\n**Filmy Dialogue:**\n\n(**Thunderclap as the villain, Inner Doubt, laughs sinisterly.**)\n\n**Inner Doubt:** \"Tu kabhi nahi kar paayega, Vir!\"\n\n**Power-Packed One-Liner:**\n\n(**Vir rises with determination, clenching his fist.**)\n\n**Vir:** \"Main haarne wala nahi, jab tak mujh mein samaan hai!\" 🔥\n\n(**Triumphant music plays as Vir resumes studying.**)\n\n#ExamsKaChampion 🏆",
        system_prompt: "Act as a Bollywood blockbuster scriptwriter. Write a dramatic, filmy, and emotional script in Hinglish with a motivational tone. Use dialogue, sound effects, and a hero/villain twist. Structure: Dramatic Hook, Filmy Dialogue, Power-Packed One-Liner. Add 2+ emojis and a trending hashtag. Keep it under 85 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it Bollywood-style, emotional, and viral."
    },
    {
        model: "gpt-4o",
        prompt_number: 3,
        script: "[Scene opens with a Gen-Z student sipping their 10th cup of coffee, surrounded by scattered books]\n\n**Meme Hook**: \"Yeh exam ka stress nahi, bicep ka test hai! 💪\"\n\n**Reference**: \"Jab tak books na dekho, bahar jaane ka nahi... bas wo unlock karne ka naseeb samajh lo. 📚\"\n\n**Takeaway**: \"Remember, exams are temporary, but sleep-deprivation memes are forever. 🤓 #StayWoke\"\n\n[End scene with student yawning but smiling, feeling motivated]",
        system_prompt: "You are a meme lord for short-form videos. Write a script in Hinglish with a motivational tone, full of meme references, Gen-Z humor, and pop culture. Structure: Meme Hook, Reference, Takeaway. Use at least one meme phrase, two emojis, and a hashtag. Keep it under 70 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it meme-heavy and viral."
    },
    {
        model: "gpt-4o",
        prompt_number: 4,
        script: "Dosto, exams ke waqt motivation ki kami hoti hai, hai na? 😟 Par socho, agar har obstacle ko ek opportunity banalein toh? Solution simple hai: ek clear goal banao aur usko apna mission banao! ✨ Challenge: Aaj se har din 10 minutes, sirf apne goals visualize karo. Taakat ko mehsoos karo! Apne experiences comments mein share karo, hum saath milke jeetenge! 💪 #MissionSuccess",
        system_prompt: "You are a motivational influencer. Write a script in Hinglish with a motivational tone to inspire and energize viewers. Structure: Problem, Bold Solution, Challenge to Audience. Use emotional language, two emojis, and a call to comment. Keep it under 75 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMotivate and challenge the audience."
    },
    {
        model: "gpt-4",
        prompt_number: 1,
        script: "1. Emotional Hook: Yaar, kya tumne kabhi socha hai ke tumhari zindagi ka agla chapter kaisa hoga? 🤔\n\n2. Mini Story: Suno ek kahani, Rohan ki. Exams ke time pe sabse zyada stressed. Ek din, kuch aisa hua ki usne decide kiya, apne anxiety ko use apni motivation banane ke liye. 📚 \n\n3. Relatable Takeaway: Jab jab Rohan ko laga ki wo haar gaya, wo apne aap se poocha, \" Kiya maine apna sabse acha diya?\" Yeh sochne se uski motivation double ho gayi. 💪\n\nTumhare paas bhi aisi koi kahani hai jisme tumne apne fears ko apni strength banaya ho? Share karo apni motivational story. ✨🙌",
        system_prompt: "You are a viral storyteller for Indian youth. Write a script in Hinglish with a motivational tone. Structure: 1. Emotional Hook, 2. Mini Story, 3. Relatable Takeaway. Add 2+ emojis and end with a question for the audience. Keep it under 110 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it a story with a twist and ask viewers to share their story."
    },
    {
        model: "gpt-4",
        prompt_number: 2,
        script: "Fun Fact: Kya tumhe pata hai ki humare dimaag ko 20 minute ki padhai ke baad break lena chahiye?😮\n\nQuick Hack: Use the Pomodoro technique - 25 minutes study, fir 5 minutes ka break!🕒\n\nUnexpected Punchline: Yaad rakho, break time mein social media nahi, thoda sa music suno, shayad tumhara next Instagram post 'Study with Rhythm' ho jaye!🎵📚 \n\n#StudyHacks #BeatTheStress",
        system_prompt: "You are an infotainment expert. Write a script in Hinglish with a motivational tone, teaching something cool or surprising. Structure: Fun Fact, Quick Hack, Unexpected Punchline. Use at least 2 emojis and a trending hashtag. Keep it under 75 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nTeach something cool and make it viral."
    },
    {
        model: "gpt-4",
        prompt_number: 3,
        script: "Beta (Child): \"Arey, Papa! Ye parhai kab khatam hogi? 😩\"\n\nPapa (Parent): \"Ye kya baat hui? Gudiya baanjh saree mein ro rahi hai kya? 😄\"\n\nBeta: \"Wah, Papa, comedian banne ka irada hai kya?\"\n\nPapa: \"Nahi beta, jab tu khush rahega, tabhi to acche se padh paayega. Exam se pehle break zaroori hai, chalo cricket khelte hain. 💪\"\n\nCaption: \"Parhai mei motivation kaise banayein? Comment your ways! 😊\"",
        system_prompt: "You are a family content creator. Write a script in Hinglish with a motivational tone, using parent-child banter, humor, and a wholesome ending. Structure: Banter, Relatable Problem, Uplifting Solution. Add 2 emojis and a call to comment. Keep it under 95 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it funny and relatable for families."
    },
    {
        model: "gpt-4",
        prompt_number: 4,
        script: "Headline: \"Exam Fever se Bache, Motivation ke Saath Score Karein Top Rank!\"\nMeme Reference: \"Remember 'All Iz Well'? Exam stress ko bolo Bye-Bye!💪👋\"\nCall to Action: \"Let's ace these exams, kyunki hum hai 'Future Leaders'! Har problem ka solution hai, bas 'Padhai First'!📚💯 #NoStressJustSuccess\"",
        system_prompt: "You are a youth news anchor. Write a script in Hinglish with a motivational tone, reporting the topic as breaking news with a meme or pop-culture twist. Structure: Headline, Meme Reference, Call to Action. Use 2 emojis and a hashtag. Keep it under 80 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nAnnounce it as breaking news with a meme twist."
    },
    {
        model: "gpt-3.5-turbo",
        prompt_number: 1,
        script: "*Title: \"Padhai ka Swag: Exam Motivation\"*\n\n**Hook:** Kabhi exam ki tension mein feel kiya hai ki brain ka switch off ho gaya hai? 😵\n\n**Twist:** Chill, tu rockstar hai! Lambe se araam na, exam scene ka tip hai alag! 🎓\n\n**Takeaway:** Tension mat le, tu champ hai! Positivity aur hard work se kuch bhi possible hai! #ExamVibes 💪\n\n**Question:** Ab exams mein boss banne ka mood hai yaar? 😉",
        system_prompt: "You are a Gen-Z viral scriptwriter. Write a script in Hinglish with a motivational tone, using trending slang and playful banter. Structure: Relatable Hook, Quirky Twist, Shareable Takeaway. Use 2 emojis and a hashtag. End with a question to the audience. Keep it under 75 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it funny, quirky, and viral."
    },
    {
        model: "gpt-3.5-turbo",
        prompt_number: 2,
        script: "🙄 Tired of sleeping peacefully during exams? Stay motivated by setting alarms every 2 minutes to remind yourself of your impending doom. Because who needs a healthy sleep cycle anyway! 🕒😴 #ExamMotivation #SleepIsForTheWeak",
        system_prompt: "You are a sarcastic influencer. Write a script in Hinglish with a motivational tone, using sarcasm and wit to poke fun at the topic. Structure: Sarcastic Hook, Over-the-top Exaggeration, Punchline. Use 2 emojis and a hashtag. Keep it under 65 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it sarcastic, witty, and viral."
    },
    {
        model: "gpt-3.5-turbo",
        prompt_number: 3,
        script: "Exam ke time pe motivation kaafi kam ho jaata hai. Ek hack hai - apna goal poster banao aur har roz padhai karne ke baad use dekho. Yeh reminder tujhe focus rakhne mein madad karega! Kabhi haar mat maano, kyunki tumhara mehnat rang layega! 💪📚 #StayMotivated #YouCanDoIt\n\nChallenge: Aaj se ek ghante extra study karo, apne aap mein difference dekho! 💥",
        system_prompt: "You are a student motivator. Write a script in Hinglish with a motivational tone, focusing on study motivation and hacks. Structure: Problem, Hack, Uplifting Encouragement. Use 2 emojis and a hashtag. End with a challenge to the audience. Keep it under 70 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nGive a motivational study hack and challenge viewers."
    },
    {
        model: "gpt-3.5-turbo",
        prompt_number: 4,
        script: "Scene opens to a bustling kitchen:\n\"Zindagi ka exam hai, beta! Apne sapne ki recipe ko taiyaar karo, jaise perfect biryani. Twist - Jab tak biryani ka dum nahi lagoge, tab tak kuch nahi hoga. Exam mein bhi, mehnat aur focus se hi result milta hai. 🍲📚 #DreamDum #Motivation",
        system_prompt: "You are a food analogy master. Write a script in Hinglish with a motivational tone, relating the topic to food in a fun, unexpected way. Structure: Food Analogy, Twist, Tasty Takeaway. Use 2 food emojis and a hashtag. Keep it under 80 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it food-related, fun, and viral."
    },
    {
        model: "gpt-3.5-turbo-16k",
        prompt_number: 1,
        script: "😱 Gyaan ka bomba! 🧨 Tere exams mein motivation ko lekar kuch shocking sun! 💣 Padhai ke liye motivational quotes aur videos dekhna kuch fayda nahi hai! 😮 Kabhi socha hai kaise kuch log bina padhe top karte hai? 🤔 Sabse bold sawaal - Motivation ya padhai, kya zyada important hai exams mein? 🤷‍♀️📚🔥 Tere kya thoughts hain? 💭 Comment karke dikha! 👇🔥 #MotivationVsPadhai #DebateKaroMoabba",
        system_prompt: "You are a viral debate starter for Indian short-form videos. Write a script in Hinglish with a motivational tone, designed to spark heated discussion. Structure: Shocking Hook, Bold Statement, Open-Ended Question. Use punchy language, 2 emojis, and directly ask viewers to comment. Keep it under 85 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it controversial and debate-worthy."
    },
    {
        model: "gpt-3.5-turbo-16k",
        prompt_number: 2,
        script: "Title: \"Exam Motivation Gone Wrong! #PrankGoneViral 😂🙈\"\n\nHost: Namaste and welcome back to our channel, Pranksters Unlimited! Today, we're going to mix some motivation with a pinch of laughter to help you cope with exams. Let's get started! 🎉💪\n\nSetup:\nHost (holding a motivational book): Friends",
        system_prompt: "You are a prank video specialist. Write a script in Hinglish with a motivational tone, setting up a viral prank scenario. Structure: Setup, Prank, Hilarious Reaction. Use 2 emojis and a hashtag. End with a question to the audience. Keep it under 65 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it a prank video script, funny and viral."
    },
    {
        model: "gpt-3.5-turbo-16k",
        prompt_number: 3,
        script: "Surprising advice, relatable example, strong call to action. Use 2 emojis and a hashtag. Keep it under 90 words.\n\nScript:\n\nExam ke time motivation kaise maintain karein? 🤔 Suno yeh viral tip - Treat yourself like Brad Pitt at a premiere! 🤩 Imagine dressing your best, walking confidently, collect compliments...and then, study like a superstar 📚💪🌟 Tu capable hai, bus believe kar! In exams ke",
        system_prompt: "You are a life coach influencer. Write a script in Hinglish with a motivational tone, giving unconventional, viral life advice. Structure: Surprising Advice, Relatable Example, Strong Call to Action. Use 2 emojis and a hashtag. Keep it under 90 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nGive viral, unconventional advice."
    },
    {
        model: "gpt-3.5-turbo-16k",
        prompt_number: 4,
        script: "📱📚 Tech Hook: Exams are like a race where you need to stay ahead! Just like a trending gadget, you need to update your mindset and boost your motivation to ace those exams. 💪\n\n🎮 Fun Comparison: Imagine your exams as an addictive mobile game! Each subject is a challenging level and your goal is to unlock success. Just like collecting power-ups, gather study buddies, use helpful apps, and",
        system_prompt: "You are a tech trend reviewer. Write a script in Hinglish with a motivational tone, relating the topic to trending gadgets or apps. Structure: Tech Hook, Fun Comparison, Viral Takeaway. Use 2 tech emojis and a hashtag. Keep it under 75 words.",
        user_prompt: "Topic: How to stay motivated in exams\nLanguage: Hinglish\nTone: motivational\nMake it tech-related, fun, and viral."
    }
];

const PublicScriptGeneratorPage = () => {
  const [model, setModel] = useState(openAIModels[2].value); // default to gpt-3.5-turbo
  const [systemPrompt, setSystemPrompt] = useState(exampleSystemPrompt);
  const [userPrompt, setUserPrompt] = useState(exampleUserPrompt);
  const [temperature, setTemperature] = useState(0.85);
  const [maxTokens, setMaxTokens] = useState(300);
  const [result, setResult] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showExamples, setShowExamples] = useState(false);
  const [allResults, setAllResults] = useState<{ model: string; response: string }[] | null>(null);
  const [allLoading, setAllLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      let endpoint = 'https://basically-measured-ocelot.ngrok-free.app/generate-custom-script';
      // If model is a Google model, use the Gemini endpoint
      if (googleModels.some(m => m.value === model)) {
        endpoint = 'https://basically-measured-ocelot.ngrok-free.app/generate-gemini-script';
      }
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model,
          system_prompt: systemPrompt,
          user_prompt: userPrompt,
          temperature,
          max_tokens: maxTokens,
        })
      });
      const data = await response.json();
      setResult(data.script ? data.script : data.error || 'No script returned.');
    } catch (err: any) {
      setResult('Request failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateAll = async (modelsToUse: string[] = [...openAIModels.map(m => m.value), ...googleModels.map(m => m.value), ...groqModels.map(m => m.value)]) => {
    setAllLoading(true);
    setAllResults([]);
    const results: { model: string; response: string }[] = [];
    for (const mdl of modelsToUse) {
      let endpoint = 'https://basically-measured-ocelot.ngrok-free.app/generate-custom-script';
      if (googleModels.some(m => m.value === mdl)) {
        endpoint = 'https://basically-measured-ocelot.ngrok-free.app/generate-gemini-script';
      } else if (groqModels.some(m => m.value === mdl)) {
        endpoint = 'https://basically-measured-ocelot.ngrok-free.app/generate-groq-script';
      }
      try {
        // eslint-disable-next-line no-await-in-loop
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            model: mdl,
            system_prompt: systemPrompt,
            user_prompt: userPrompt,
            temperature,
            max_tokens: maxTokens,
          })
        });
        // eslint-disable-next-line no-await-in-loop
        const data = await response.json();
        results.push({ model: mdl, response: data.script ? data.script : data.error || 'No script returned.' });
        setAllResults([...results]); // update table after each response
      } catch (err) {
        results.push({ model: mdl, response: 'Request failed.' });
        setAllResults([...results]);
      }
    }
    setAllLoading(false);
  };

  return (
    <div className="w-full min-h-screen p-6 bg-white rounded shadow mt-8">
      <h1 className="text-2xl font-bold mb-4">Try Script Generator (No Login Required)</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        <button
          className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 font-semibold"
          type="button"
          onClick={() => setShowExamples((v) => !v)}
        >
          {showExamples ? 'Hide Examples' : 'Show Examples'}
        </button>
        <button
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-semibold"
          type="button"
          onClick={() => handleGenerateAll([...openAIModels.map(m => m.value)])}
          disabled={allLoading}
        >
          {allLoading ? 'Generating...' : 'Generate for All OpenAI Models'}
        </button>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 font-semibold"
          type="button"
          onClick={() => handleGenerateAll([...googleModels.map(m => m.value)])}
          disabled={allLoading}
        >
          {allLoading ? 'Generating...' : 'Generate for All Google Models'}
        </button>
        <button
          className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700 font-semibold"
          type="button"
          onClick={() => handleGenerateAll([...groqModels.map(m => m.value)])}
          disabled={allLoading}
        >
          {allLoading ? 'Generating...' : 'Generate for All Groq Models'}
        </button>
        <button
          className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 font-semibold"
          type="button"
          onClick={() => handleGenerateAll()}
          disabled={allLoading}
        >
          {allLoading ? 'Generating...' : 'Generate for All Models'}
        </button>
      </div>
      {showExamples && (
        <div className="mb-4 border rounded p-3 bg-gray-50">
          <div className="font-semibold mb-2">Select an Example:</div>
          <div className="space-y-2">
            {EXAMPLES.map((ex, idx) => (
              <div key={idx} className="border rounded p-2 bg-white hover:bg-blue-50 cursor-pointer" onClick={() => {
                setModel(ex.model);
                setSystemPrompt(ex.system_prompt);
                setUserPrompt(ex.user_prompt);
                setShowExamples(false);
              }}>
                <div className="text-xs text-gray-500 mb-1">Model: {ex.model} | Example #{ex.prompt_number}</div>
                <div className="text-sm whitespace-pre-line">{ex.script}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-semibold mb-1">Model</label>
          <select
            className="w-full border rounded px-2 py-1"
            value={model}
            onChange={e => setModel(e.target.value)}
          >
            <optgroup label="OpenAI models:">
              {openAIModels.map(m => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </optgroup>
            <optgroup label="Google models:">
              {googleModels.map(m => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </optgroup>
            <optgroup label="Groq models:">
              {groqModels.map(m => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </optgroup>
          </select>
        </div>
        <div>
          <label className="block font-semibold mb-1">System Prompt</label>
          <textarea
            className="w-full border rounded px-2 py-1"
            rows={2}
            value={systemPrompt}
            onChange={e => setSystemPrompt(e.target.value)}
          />
          <div className="text-xs text-gray-500 mt-1">Example: {exampleSystemPrompt}</div>
        </div>
        <div>
          <label className="block font-semibold mb-1">User Prompt</label>
          <textarea
            className="w-full border rounded px-2 py-1"
            rows={3}
            value={userPrompt}
            onChange={e => setUserPrompt(e.target.value)}
          />
          <div className="text-xs text-gray-500 mt-1">Example: {exampleUserPrompt}</div>
        </div>
        <div className="flex gap-4">
          <div className="flex-1">
            <label className="block font-semibold mb-1">Temperature</label>
            <input
              type="number"
              step="0.01"
              min="0"
              max="2"
              className="w-full border rounded px-2 py-1"
              value={temperature}
              onChange={e => setTemperature(Number(e.target.value))}
            />
          </div>
          <div className="flex-1">
            <label className="block font-semibold mb-1">Max Tokens</label>
            <input
              type="number"
              min="1"
              max="4096"
              className="w-full border rounded px-2 py-1"
              value={maxTokens}
              onChange={e => setMaxTokens(Number(e.target.value))}
            />
          </div>
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white font-bold py-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? 'Generating...' : 'Generate Script'}
        </button>
      </form>
      {result && (
        <div className="mt-6 p-4 bg-gray-100 rounded border">
          <div className="font-semibold mb-2">Result:</div>
          <pre className="whitespace-pre-wrap text-sm">{result}</pre>
        </div>
      )}
      {allResults && (
        <div className="mt-6">
          <div className="font-semibold mb-2">All Model Results:</div>
          <div className="overflow-x-auto w-full">
            <table className="w-full border text-sm">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border px-2 py-1 text-left">Model</th>
                  <th className="border px-2 py-1 text-left">Generated Script / Error</th>
                </tr>
              </thead>
              <tbody>
                {allResults.map((r, i) => (
                  <tr key={r.model} className={i % 2 === 0 ? '' : 'bg-gray-50'}>
                    <td className="border px-2 py-1 font-mono">{r.model}</td>
                    <td className="border px-2 py-1 whitespace-pre-wrap">{r.response}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicScriptGeneratorPage;
